/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxGamesIntegrationOneStoreOneStoreMarketClassification } from './FxGamesIntegrationOneStoreOneStoreMarketClassification';
import {
    FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSON,
    FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSONTyped,
    FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSON,
    FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSONTyped,
} from './FxGamesIntegrationOneStoreOneStoreMarketClassification';

/**
 * 
 * @export
 * @interface FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData
 */
export interface FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData
     */
    Token: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData
     */
    DeveloperPayload: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData
     */
    Sku: string;
    /**
     * 
     * @type {FxGamesIntegrationOneStoreOneStoreMarketClassification}
     * @memberof FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData
     */
    MarketClassification: FxGamesIntegrationOneStoreOneStoreMarketClassification;
}



/**
 * Check if a given object implements the FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData(value: object): value is FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    if (!('MarketClassification' in value) || value['MarketClassification'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData {
    return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
        'MarketClassification': FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSON(json['MarketClassification']),
    };
}

export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSON(json: any): FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData {
    return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
        'MarketClassification': FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSON(value['MarketClassification']),
    };
}

